import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/united-kingdom.png")